export const survey = [
    {
        "id": 1,
        "question": "How are teams organized and resourced?",
        "options": [
            {
                "choice": "All IT assets are funded annually by projects and ‘run’ budgets",
                "score": 0
            },
            {
                "choice": "Internal platforms and shared services are operationally funded; external-facing products are delivered by cross-functional teams",
                "score": 1
            },
            {
                "choice": "Most of our portfolio, including some internal platforms, is delivered by cross-functional build-and-run teams; funding is annual or semi-annual",
                "score": 2
            },
            {
                "choice": "The entire portfolio is organized in continuously funded cross-functional build-and-run teams",
                "score": 3
            }
        ]
    },
    {
        "id": 2,
        "question": "How strong is customer centricity?",
        "options": [
            {
                "choice": "Most individuals would find it difficult to identify their customers",
                "score": 0
            },
            {
                "choice": "Our external-facing applications can clearly identify their customers but we have no programmatic feedback mechanisms in place",
                "score": 1
            },
            {
                "choice": "Most of our portfolio can clearly identify their customers; some mechanisms for customer feedback are in place but they are not universal",
                "score": 2
            },
            {
                "choice": "Product managers have regular meetings with internal customers and programmatic mechanisms to gather and respond to feedback",
                "score": 3
            }
        ]
    },
    {
        "id": 3,
        "question": "How clear is the definition of value?",
        "options": [
            {
                "choice": "Most individuals would be hard-pressed to explain how they contribute to tangible business outcomes",
                "score": 0
            },
            {
                "choice": "A few leaders can articulate the business drivers",
                "score": 1
            },
            {
                "choice": "Most product managers can articulate the value they provide to their customers and the business",
                "score": 2
            },
            {
                "choice": "Value is well-defined and serves as a focal point for every single team member",
                "score": 3
            }
        ]
    },
    {
        "id": 4,
        "question": "How are backlogs managed and prioritized?",
        "options": [
            {
                "choice": "Programs, projects and Gantt charts drive the backlog",
                "score": 0
            },
            {
                "choice": "A primary business stakeholder dictates desired features, and portfolio managers commit teams to the work",
                "score": 1
            },
            {
                "choice": "Product managers create execution plans to deliver desired capabilities on an annual planning cycle",
                "score": 2
            },
            {
                "choice": "Product managers are the long-term custodians of product vision, roadmap and viability",
                "score": 3
            }
        ]
    },
    {
        "id": 5,
        "question": "How are dependencies managed?",
        "options": [
            {
                "choice": "The execution path involves SLAs with functional areas",
                "score": 0
            },
            {
                "choice": "Technical, process and skill dependencies slow down most deliveries",
                "score": 1
            },
            {
                "choice": "Some internally consumed capabilities are self-service but others still require handoffs and coordination",
                "score": 2
            },
            {
                "choice": "All internally consumed capabilities are available as self-service",
                "score": 3
            }
        ]
    },
    {
        "id": 6,
        "question": "How rapidly can customer feedback revise planning?",
        "options": [
            {
                "choice": "An enterprise schedule provides highly governed release windows a few times a year",
                "score": 0
            },
            {
                "choice": "In case of emergency, applications can release independently to production",
                "score": 1
            },
            {
                "choice": "Some applications have an independent path to production and are able to incorporate customer feedback within a quarter",
                "score": 2
            },
            {
                "choice": "All products have an automated, an independent path to production and are able to incorporate customer feedback within weeks",
                "score": 3
            }
        ]
    },
    {
        "id": 7,
        "question": "How are delivery teams measured?",
        "options": [
            {
                "choice": "Primarily with quality and cost metrics",
                "score": 0
            },
            {
                "choice": "Agile, DORA and Engineering metrics",
                "score": 1
            },
            {
                "choice": "Flow metrics are measured in addition to Agile, DORA and Engineering metrics",
                "score": 2
            },
            {
                "choice": "Flow metrics and business outcomes are incorporated in operational reviews at all levels",
                "score": 3
            }
        ]
    }
]